module.exports = __webpack_public_path__ + "static/media/five-star-rating.71a9d85f.png";